module.exports = __webpack_public_path__ + "media/coffee-preferences/brew_method_chemex-d7173aa5.png";